export const STRIPE_STATUS = {
  REQUIRED_PAYMENT_METHOD: "required_payment_method",
  SUCCESS: "succeeded",
};

export const PAYMENT_TYPES = {
  NO_SAVE: "no_save",
  SAVE_REQUIRED: "save_required",
  FROM_SAVED_METHOD: "from_saved_method",
};

export const PAYMENT_RESPONSE = {
  REQUIRED_ACTION: "required_action",
  VALIDATION_ERROR: "validation_error",
  INTEGRATION_ERROR: "IntegrationError",
};

export const CARD_TYPES = {
  VISA: "visa",
  MASTERCARD: "mastercard",
};

export const PAYMENT_SESSION = {
  STRIPE_ACTIVATED: "stripe-sepa-debit-saved",
  GCL_ACTIVATED: "gcl-saved",
  CB_SESSION: "cb-session",
  STRIPE_DEBIT_SESSION: "stripe-sepa-debit",
  DIRECT_DEBIT_SESSION: "direct-mandate-debit-session",
};
